import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_APPLICATION_OWNER,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
  CAMPAIGNTYPE_SERVICEACCOUNT,
  CAMPAIGNTYPE_USERMANAGER,
} from '../../../utils/constant';

const getParentLineitem = (campaignType) => {
  let title = 'User';

  switch (CAMPAIGN_TYPES[campaignType]) {
    case CAMPAIGNTYPE_USERMANAGER:
      title = 'User';
      break;
    case CAMPAIGNTYPE_APPLICATION_OWNER:
    case CAMPAIGNTYPE_SERVICEACCOUNT:
      title = 'Account';
      break;
    case CAMPAIGNTYPE_ENTITLEMENTOWNER:
      title = 'Entitlement';
      break;
    default:
      break;
  }

  return title;
};

export default getParentLineitem;
